import objectHash from 'object-hash'
import dayjs from "dayjs";
import { cloneDeep, mapKeys, snakeCase, camelCase, isObject } from 'lodash';

export const objectHasChanges = (current, previous) => {
  const hashingOptions = {
    replacer: (field) => {
      return (field instanceof Date && !isNaN(field)) ? dayjs(field).toISOString() : field
    }
  }
  const currentHash = objectHash(cloneDeep(current), hashingOptions)
  const previousHash = objectHash(cloneDeep(previous), hashingOptions)

  return currentHash !== previousHash
}

export function keysToSnakeCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => keysToSnakeCase(item))
  } else if (isObject(obj)) {
    return mapKeys(obj, (value, key) => snakeCase(key))
  }

  return obj
}

export function keysToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => keysToCamelCase(item))
  } else if (isObject(obj)) {
    return mapKeys(obj, (value, key) => camelCase(key))
  }

  return obj
}
